export enum PlanStep {
  DETERMINE_CURRENT_REALITY,
  EXPLORE_THE_FUTURE,
  SYNTHESIZE_RESULTS,

  CREATE_OBJECTIVES_AND_CRITICAL_INITIATIVES,
  IDENTIFY_OUTCOMES_AND_KEY_MEASURES,
  DEVELOP_STRATEGY_MAP,
  DEVELOP_THE_ANNUAL_PLAN,

  DESIGN_THE_IMPLEMENTATION_PLAN,
  ASSIGN_AND_COMMUNICATE_RESPONSIBILITIES,
  ENACT_AND_MONITOR_PROGRESS,

  DETERMINE_IMPACT_OF_CRITICAL_INITIATIVES,
  JUDGE_SUCCESS_OF_ANNUAL_PLAN,
  ADDRESS_IMPLICATIONS_FOR_FUTURE_WORK,

  OUTPUTS
}
